export default {
  text: '#1a1a1a',
  primary: '#330000',
  secondary: '#e7e7e7',
  background: '#e1e1e1',
  backgroundSecondary: 'lightgrey',
  light: '#fdfdfd',
  dark: '#020303'
}
